export default __webpack_public_path__ + "static/media/ms-symbollockup_signin_light.e2f600a8.svg";